<template>
  <div class="faq-gift-box-limited">
    <section class="discover-section faq-section">
      <div class="container-fluid">
        <div class="add-padding">
          <div class="top-content d-flex justify-content-start align-items-start">
            <p  class="mb-0" :class="isPhone ? 'merriweather-reg-20 text-center' : 'merriweather-reg-24'">FAQ</p>
          </div>
          <div class="accordion mt-3" id="faqAccordion" v-if="selectedType === 'entreprise'">
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                >
                    Qu'est-ce que le coffret cadeau Hortense ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseOne"
                    class="collapse"
                    aria-labelledby="headingOne"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body pl-2">
                        <p>
                            Le coffret cadeau Hortense est une invitation à vivre une évasion éco-responsable dans des hébergements de charme triés sur le volet. Il permet d'offrir – ou de s'offrir – un séjour unique dans des lieux engagés, alliant confort, authenticité et respect de l'environnement. Chaque coffret comprend une carte cadeau utilisable librement sur l'ensemble de notre sélection d'adresses, avec 24 mois pour réserver l'expérience de votre choix.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 2 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                >
                    À qui s'adresse ce coffret cadeau ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseTwo"
                    class="collapse"
                    aria-labelledby="headingTwo"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body pl-2">
                        <p>
                            Il s'adresse à toutes les personnes en quête d'évasion, de nature, d'authenticité et de sens. Il est parfait pour les amateurs de belles adresses, les voyageurs soucieux de leur impact et les amoureux de séjours éco-responsables.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 3 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                >
                    Peut-on offrir un coffret sans connaître la date du futur séjour ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseThree"
                    class="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body pl-2">
                        <p>
                            Oui, absolument. Le bénéficiaire est libre de choisir la date et l'hébergement qui lui conviennent, dans la limite de validité de la carte cadeau, fixée à 24 mois à compter de la date d'achat.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 4 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                >
                    Comment le bénéficiaire utilise-t-il le coffret ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseFour"
                    class="collapse"
                    aria-labelledby="headingFour"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body pl-2">
                        <p>
                            Le bénéficiaire se rend sur notre site hortense.green, explore notre sélection d'hébergements éco-responsables et choisit celui qui lui plaît. Lors de la réservation, il saisit le code de sa carte cadeau dans le champ prévu à cet effet pour utiliser son crédit.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 5 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                >
                    Est-ce que le coffret est nominatif ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseFive"
                    class="collapse"
                    aria-labelledby="headingFive"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body pl-2">
                        <p>
                            Non, le coffret n'est pas nominatif. Il peut être offert à la personne de votre choix, qui pourra ensuite réserver en toute autonomie.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Question 6 -->
            <div class="card border-bottom">
                <button
                    class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                >
                    Que contient le coffret cadeau Hortense ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div
                    id="collapseSix"
                    class="collapse"
                    aria-labelledby="headingSix"
                    data-parent="#faqAccordion"
                >
                    <div class="card-body pl-2">
                        <p>Un coffret comprend :</p>
                        <ul>
                            <li>une carte cadeau d'un montant libre entre 100 € et 1000 €,</li>
                            <li>un guide de voyage "Découvrez la France autrement",</li>
                            <li>une pochette éco-friendly,</li>
                            <li>un service de conciergerie sur-mesure,</li>
                            <li>un privilège exclusif (avantage ou expérience en plus selon l'hébergement).</li>
                        </ul>
                    </div>
                </div>
            </div>
          </div>
          <div class="accordion mt-5" id="faqAccordion" v-else>
            <!-- Question 1 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                    À qui s'adresse l'offre coffret cadeau Hortense en BtoB ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#faqAccordion">
                    <div class="card-body pl-2">
                        <p>L'offre coffret cadeau Hortense en BtoB s'adresse aux entreprises, CSE, agences événementielles, distributeurs ou associations souhaitant offrir un cadeau porteur de sens à leurs collaborateurs, clients ou partenaires. Nos coffrets permettent d'offrir une expérience unique, responsable et mémorable, en lien avec les valeurs d'un tourisme durable. Ils s'intègrent parfaitement dans une démarche RSE, une opération de fidélisation, une dotation événementielle ou un programme d'incentive.</p>
                    </div>
                </div>
            </div>

            <!-- Question 2 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Dans quels cas offrir un coffret Hortense ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#faqAccordion">
                    <div class="card-body pl-2">
                        <p>Le coffret Hortense est une idée cadeau idéale pour les entreprises, CSE et associations souhaitant valoriser, fidéliser ou remercier de manière engagée. Il peut être offert dans de nombreux contextes professionnels :<br>
                        - Cadeaux de fin d'année<br>
                        - Récompenses ou challenges commerciaux<br>
                        - Opérations de fidélisation ou d'incentive<br>
                        - Dotations événementielles ou animations CSE<br>
                        - Actions RSE ou QVT (Qualité de Vie au Travail)<br>
                        Avec Hortense, vous offrez plus qu'un cadeau : une expérience éco-responsable, authentique et mémorable, en parfaite cohérence avec vos valeurs.</p>
                    </div>
                </div>
            </div>

            <!-- Question 3 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Comment fonctionne le coffret pour l'entreprise ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#faqAccordion">
                    <div class="card-body pl-2">
                        <p>Vous choisissez le nombre de coffrets, le format (physique ou e-coffret), le montant unitaire de la carte cadeau (entre 100 € et 1000 €) et les options (guide papier, message personnalisé, livraison groupée ou individuelle).</p>
                    </div>
                </div>
            </div>

            <!-- Question 4 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    Peut-on personnaliser les coffrets aux couleurs de notre entreprise ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#faqAccordion">
                    <div class="card-body pl-2">
                        <p>Oui, nous proposons des options de personnalisation sur mesure pour les entreprises. Il est possible d'ajouter votre logo, un mot personnalisé pour les bénéficiaires, ou même de créer un habillage aux couleurs de votre marque (coffret, pochette, carte cadeau, insert). Cette personnalisation permet d'offrir un cadeau à votre image, à la fois élégant et engagé. Notre équipe vous accompagne pour concevoir un coffret unique, en cohérence avec votre message et vos valeurs.</p>
                    </div>
                </div>
            </div>

            <!-- Question 5 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    Que contient chaque coffret Hortense ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#faqAccordion">
                    <div class="card-body pl-2">
                        <p>Un coffret comprend :</p>
                        <ul>
                          <li>une carte cadeau d'un montant libre entre 100 € et 1000 €,</li>
                          <li>un guide de voyage "Découvrez la France autrement",</li>
                          <li>une pochette éco-friendly,</li>
                          <li>un service de conciergerie sur-mesure,</li>
                        </ul>
                        <p>un privilège exclusif (avantage ou expérience en plus selon l'hébergement).</p>
                    </div>
                </div>
            </div>

            <!-- Question 6 -->
            <div class="card border-bottom">
                <button class="btn btn-link btn-block w-100 text-left collapsed d-flex justify-content-between pr-3 pl-2" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                    Quelles sont les options disponibles ?
                    <i class="fa-solid fa-chevron-up"></i>
                </button>
                <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#faqAccordion">
                    <div class="card-body pl-2">
                        <ul>
                          <li>E-coffret (immédiat) ou coffret physique</li>
                          <li>Livraison en un point unique ou dispatch à plusieurs adresses</li>
                          <li>Personnalisation graphique ou éditoriale</li>
                        </ul>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="d-flex w-100 justify-content-center align-items-center my-5" :class="{ 'px-5': isPhone }">
      <div class="hortense-btn-primary" @click="goToLink(selectedType == 'entreprise' ? '/faq-coffrets-cadeaux' : 'faq-coffrets-cadeaux-entreprise')">
        CONSULTEZ NOTRE FAQ COMPLÈTE
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GiftBoxLimitedFaqs',
  props: {
    selectedType: {
      type: String,
      required: true,
      default: 'entreprise'
    }
  },
  data() {
    return {
      isPhone: window.innerWidth <= 768
    };
  },
  methods: {
    goToLink(link) {
      window.open(link, '_blank');
    }
  }
};
</script>
<style scoped lang="scss">
  .discover-section {
    .top-content {
      margin: 0 7% 0 7%;
      @media screen and (max-width: 768px) {
        margin: 0 1% 0 1%;
      }
    }
  }
  .faq-section {
    margin-top: 55px;

    @media screen and (max-width: 768px) {
      margin-top: 120px;
    }
    .top-content {
      h2 {
        font-size: 40px;
      }
    }

    #faqAccordion {
      padding: 0 7%;
      @media screen and (max-width: 768px) {
        padding: 0 1%;
      }
    }

    .btn-link {
      color: white;
      text-decoration: none;
      font-weight: 600;
      display: block;
      text-align: left;
      width: 100%;
      background-color: #365a48;
      border-bottom: none;
      padding-left: 0;
      padding: 15px 0px;
      transition: padding 0.3s ease-in-out;
      box-shadow: none;
      border-radius: 0px;
      font-size: 16px;
      line-height: 20px;
      font-family: "Raleway", sans-serif;
      align-items: center;
      gap: 12px;
      text-transform: uppercase;
    }

    .btn-link.collapsed {
      color: #000000;
      background-color: #ffffff;
      padding-left: 20px;

      &:hover {
        background-color: #365a48;
        color: #ffffff;
      }
    }

    .card {
      border: none;
      margin-bottom: 10px;
    }

    .card-body {
      p,
      li {
        font-size: 16px;
        color: #000000;
        font-family: "Raleway", sans-serif;
        margin-bottom: 0;
        line-height: 35px;

        span {
          font-weight: 700;
        }
        &.external-links {
          a {
            color: #000000;
            text-decoration: underline;
          }
        }
      }

      ul {
        padding-left: 20px;
      }
    }

    .arrow-icon {
      display: inline-block;
      width: 12px;
      height: 12px;
      border-right: 2px solid white;
      border-bottom: 2px solid white;
      transform: rotate(45deg);
      transition: transform 0.3s ease;
      margin-left: 10px;
    }

    /* Rotate arrow when expanded */
    button[aria-expanded="false"] i {
      transform: rotate(180deg);
    }
  }

  .selection-btns-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 50px;

    @media screen and (max-width: 768px) {
      gap: 6px;
      flex-direction: column;
    }

    .selection-button {
      padding: 19px;
      border-radius: 19px;
      border: 2px solid #3B6152;
      color: #3B6152;
      width: 251px;
      height: 37px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: $Raleway;
      font-weight: 600;
      font-size: 15px;
      cursor: pointer;
    }
    .selected {
      background-color: #3B6152;
      color: white;
    }
  }
</style>